import { render, staticRenderFns } from "./SummariesData.vue?vue&type=template&id=5670aa03&scoped=true"
import script from "./SummariesData.vue?vue&type=script&lang=js"
export * from "./SummariesData.vue?vue&type=script&lang=js"
import style0 from "./SummariesData.vue?vue&type=style&index=0&id=5670aa03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5670aa03",
  null
  
)

export default component.exports